import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-71" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-72" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-73" data-mp="32m1bayt2r0om">
          THE AUTONOMOUS CHILD VISUAL SYSTEM<span className="align-super text-xs" data-id="element-74" data-mp="36n3cvmagrotr">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-75" data-mp="3ufjw405xtmun">
          Create a personalized visual routine for morning, afternoon and bedtime, and accompany
          each activity step by step. Stop managing your child's day — start guiding them to manage
          it themselves.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-76" data-mp="3qfjighqnxfon">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="2a1jlnfn4665m">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3labovo69tsmo" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="https://instagram.com/sigmasmart.en" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-79" data-mp="3gbr0qn4amzel">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-80" data-mp="3q8n30b3lmpap" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-blush" data-id="element-81" data-mp="82idhvaq8efw">
          🧩 “One thing at a time.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-82" data-mp="335tdib8plh0">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="hrihxu80021h">
            Terms & Conditions
          </a>
          <span data-id="element-84" data-mp="cw3595lq8c6n">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="qt8flhsh3x7p">
            Privacy Policy
          </a>
          <span data-id="element-86" data-mp="mt7rt6jhi9nz">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-87" data-mp="mtraipgyl232">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-88" data-mp="ytxyzp4ywl2j">
          © 2026 SIGMA SMART™ · All rights reserved. The Autonomous Child Visual System™ is a
          digital educational product. It is not a substitute for professional psychological or
          medical advice.
        </p>
      </div>
    </footer>;
}